import network from '@Utils/network';

const prefix = 'BOOT';

const CONFIG_REQUEST = `${prefix}_CONFIG_REQUEST`;
const CONFIG_SUCCESS = `${prefix}_CONFIG_SUCCESS`;
const CONFIG_FAILURE = `${prefix}_CONFIG_FAILURE`;

const fetchConfig = () => async (dispatch) => {
  try {
    dispatch({ type: CONFIG_REQUEST });
    const response = await network.get('/config.json');
    if (response) {
      dispatch({
        type: CONFIG_SUCCESS,
        payload: response,
      });
    }
  } catch (err) {
    throw Error(err);
  }
};

export default {
  CONFIG_REQUEST,
  CONFIG_SUCCESS,
  CONFIG_FAILURE,
  fetchConfig,
};
